import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "booking-service";

export default {
    getSchedulesByMonth(yearMonth) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL +
                    "/cms/booking/schedule/get/calendar/" +
                    yearMonth,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSchedulesByWeek(week) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL +
                    "/cms/booking/schedule/get/week/" +
                    week,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSchedulesByDay(day) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL +
                    "/cms/booking/schedule/get/date/" +
                    day,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    viewSchedule(scheduleUuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/cms/booking/schedule/view/" + scheduleUuid,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getAttendees(scheduleUuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL +
                    "/cms/booking/schedule/get/attendees/" +
                    scheduleUuid,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getRoomOptions() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/cms/booking/options/rooms", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getClassOptions() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/cms/booking/options/classes", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getInstructorOptions() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/cms/booking/options/instructors", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getBranchOptions() {
        const BASE_SERVICE_URL = "/organization-service";
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/branch/list", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    createSchedule(data) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/cms/booking/schedule/create", data, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateSchedule(uuid, data) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/cms/booking/schedule/update/" + uuid,
                data,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
